import { render } from "./ListOfPayments.vue?vue&type=template&id=f956b1e4&scoped=true&ts=true"
import script from "./ListOfPayments.vue?vue&type=script&lang=ts"
export * from "./ListOfPayments.vue?vue&type=script&lang=ts"

import "./ListOfPayments.vue?vue&type=style&index=0&id=f956b1e4&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f956b1e4"]])

export default __exports__